import React, { useMemo } from 'react'
import { makeSafeHtml } from '../../utils/makeSafeHtml'

function SafeHtml ({
    html,
    className,
    as: Component = 'div',
    fallback = null,
    ...props
}) {
    const safeHtml = useMemo(() => makeSafeHtml(html), [html])

    if (!safeHtml) {
        return fallback
    }

    return (
        <Component
            className={className}
            dangerouslySetInnerHTML={{ __html: safeHtml }}
            {...props}
        />
    )
}

export default SafeHtml
